var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C2.23858 0 0 2.23858 0 5V15C0 17.7614 2.23858 20 5 20H15C17.7614 20 20 17.7614 20 15V5C20 2.23858 17.7614 0 15 0H5ZM6 7C6 6.44772 6.44772 6 7 6C7.55228 6 8 6.44772 8 7C8 7.55229 7.55228 8 7 8C6.44772 8 6 7.55229 6 7ZM7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10C8.65685 10 10 8.65685 10 7C10 5.34315 8.65685 4 7 4ZM12.5063 12.2179C12.8541 11.7833 13.4892 11.7166 13.9194 12.0678L15.8409 13.7519C16.2562 14.116 16.888 14.0744 17.252 13.659C17.6161 13.2437 17.5745 12.6119 17.1591 12.2479L15.2173 10.5459L15.2077 10.538C13.9169 9.46224 11.9943 9.65642 10.9446 10.9685L9.34539 12.9675C9.03227 13.3589 8.47184 13.4459 8.05478 13.1679C6.78021 12.3182 5.06947 12.5791 4.10585 13.7671L2.7429 15.3466C2.38211 15.7648 2.42859 16.3962 2.84673 16.757C3.26487 17.1178 3.89633 17.0713 4.25713 16.6532L5.64315 15.0469L5.65476 15.0324C5.96789 14.641 6.52831 14.554 6.94538 14.832C8.22562 15.6855 9.94594 15.4184 10.9071 14.2169L12.5063 12.2179Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.78d4fe8403107f0808687ed45bbab18d.svg";
export { ForwardRef as ReactComponent };